import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=05cf732a"
import script from "./EventItem.vue?vue&type=script&lang=js"
export * from "./EventItem.vue?vue&type=script&lang=js"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=05cf732a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports